// Centralized application configuration read from environment variables
const API_BASE = process.env.REACT_APP_API_BASE_URL || "";
const AGENT_BASE = process.env.REACT_APP_AGENT_API_BASE_URL || "";
const SESSION_BASE = process.env.REACT_APP_SESSION_API_BASE_URL || "http://localhost:8000";
const MSAL_CLIENT_ID = process.env.REACT_APP_MSAL_CLIENT_ID || "";
const MSAL_TENANT_ID = process.env.REACT_APP_MSAL_TENANT_ID || "";
// const MSAL_AUTHORITY_URL = process.env.REACT_APP_MSAL_AUTHORITY_URL || `https://bluegeckosso.ciamlogin.com/${MSAL_TENANT_ID}`;
const DEFAULT_USER = process.env.REACT_APP_DEFAULT_USER || "default_user";
const PRODUCT_CHEETAH_URL = process.env.REACT_APP_PRODUCT_CHEETAH_URL;
const PRODUCT_OWL_URL = process.env.REACT_APP_PRODUCT_OWL_URL;
export default {
  API_BASE,
  AGENT_BASE,
  SESSION_BASE,
  MSAL_CLIENT_ID,
  MSAL_TENANT_ID,
  // MSAL_AUTHORITY_URL,
  DEFAULT_USER,
  PRODUCT_CHEETAH_URL,
  PRODUCT_OWL_URL,
};
